module.exports = __webpack_public_path__ + "img/191.e415766f.png";